import { storeTypes, setActiveTypes } from "../typesSlice";

const fallbackPaths = (controller, scope) => [
  `${controller}/${scope}/identity_types.json`,
  `${controller}/identity_types.json`,
  `global/${scope}/identity_types.json`,
  `global/identity_types.json`,
];
export const fetchTypesWithFallback =
  (controller, scope) => async (dispatch, getState) => {
    const cache = getState().types;
    const paths = fallbackPaths(controller, scope);

    for (const path of paths) {
      if (cache?.hasOwnProperty(path)) {
        if (cache[path] !== null) {
          dispatch(setActiveTypes(cache[path]));
          break;
        } else {
          continue;
        }
      }

      try {
        const res = await fetch(`${import.meta.env.VITE_DOMAIN}/${path}`);
        if (res.ok) {
          const data = await res.json();
          dispatch(storeTypes({ path, data }));
          break;
        } else {
          dispatch(storeTypes({ path, data: null }));
        }
      } catch {
        dispatch(storeTypes({ path, data: null }));
      }
    }

    throw new Error("No types.json found in fallback paths");
  };
